export function normalizeSessionFailureCode(code: string) {
  return code
    .replace(/^functions[/-]/iu, '')
    .replaceAll('_', '-')
    .toUpperCase();
}
